import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  notification,
  Radio,
  Row,
  Select,
  Space,
  Switch,
  Table,
  Typography,
} from "antd";
import {  useHistory } from "react-router-dom";
import API_SERVICE from "shared/services/api-service";
import add from "../../../assets/images/add.svg";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import { setScreenHeader } from "shared/redux/common-reducer";
import { RootState } from "shared/redux/store";
import { getEnumValue } from "shared/services/Utility";
import { NUMBER_REGEX } from "shared/constants/AppConstants";
import { ColumnsType } from "antd/lib/table";
import { setActiveKey } from "shared/redux/lead-reducer";

const { Option } = Select;
const { Title, Text } = Typography;

type Props = {};

const AddLender: React.FunctionComponent<Props> = () => {
  const history = useHistory();
  const [fiList, setFiList] = useState([] as any);
  const [pIDetailList, setPIDetailList] = useState([] as any);
  const [hubList, setHubList] = useState([] as any);
  const [products, setProducts] = useState([] as any);
  const [regionalDSAID, setRegionalDSAID] = useState([""]);
  const [selectedDSAId, setSelectedDSAId] = useState(1);
  const [showDSAIdView, setShowDSAIdView] = useState(false);
  const [individualCaseRouting, setIndividualCaseRouting] = useState(false);
  const [bulkCaseRouting, setBulkCaseRouting] = useState(false);
  const [routingMode, setRoutingMode] = useState("");
  const [routingModeBulk, setRoutingModeBulk] = useState("LOGIN");
  const [selectedLenderId, setSelectedLenderId] = useState(undefined);
  const [selectedLoanProductCode, setSelectedLoanProductCode] =
    useState<any>(undefined);
  const [productList, setProductsList] = useState([] as any);
  const [productPlan, setProductPlan]=useState([] as any)
  const [productPlanList, setProductPlanList] = useState([] as any);//useState(productPlanData)
  const [loading, setLoading] = useState(true);
  const [consentRequired, setConsentRequired] = useState(true);
  const [consentType, setConsentType] = useState('GLOBAL') as any;
  const [addLenderForm] = Form.useForm() as any;
  const [aggregatorList, setAggregatorList] = useState([]) as any;
  const [selectedProductPlan, setSelectedProductPlan] = useState("")
  const [selectedAggregator, setSelectedAggregator] = useState("")
  const [selectedProductPlanName, setSelectedProductPlanName] = useState("")
  const {appColors}: any = useSelector((state: RootState) => state.common);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setScreenHeader({
        backScreenTitle: "Lender",
        backScreenPath: "/lenders",
        screenTitle: "Add New Lender",
      })
    );
    // setAggregatorList(aggregatorData)
  }, []);

  const addLender = (values: any) => {
    if(!individualCaseRouting && !bulkCaseRouting) {
      notification.error({message:"Please select at lease 1 Case Routing"})
      return;
    }

    if (routingMode == "API" &&  selectedLoanProductCode?.loanProductName !== "Credit Card") {
       updatePartnerIdentificationDetails(values);
    } else {
      addLenderHandler(values);
    }
  };

  const addLenderHandler = (values: any) => {
    const routingConfigurationSet: any = [];
    const productPlanDetails: any = []
       if(individualCaseRouting) {
      routingConfigurationSet.push({
        routingType: "INDIVIDUAL",
        status: individualCaseRouting ? "ACTIVE" : "INACTIVE",
        hub: values.hub,
        pincode: values.pincode,
        city: values.city,
        lenderLoginUrl:values.lenderLoginUrl,
        submissionType: routingMode.length>0?routingMode:"API",
      })
    }

    if (bulkCaseRouting) {
      const keys = Object.keys(values);
      const filterDataObject = keys
        .filter((key) => key.endsWith("_bulk") && key !== "routingMode_bulk")
        .map((key) => ({
          key: key.replace("_bulk", ""),
          value: values[key],
        }));

      routingConfigurationSet.push({
        routingType: "BULK",
        status: bulkCaseRouting ? "ACTIVE" : "INACTIVE",
        hub: values.hub_bulk,
        pincode: values.pincode_bulk,
        city: values.city_bulk,
        lenderLoginUrl:values.lenderLoginUrl_bulk,
        submissionType: routingModeBulk,
        partnerIdentificationDetails: filterDataObject,
      });
    }

    const selectedBank = fiList.find(
      (item: any) => item.financierName === values.bankName
    );
    productPlanDetails.push({
        productPlanId:values?.productPlan,
        status:"ACTIVE"
      })
     const payload = {
      active: values.status,
      consentType     : (consentType==="Noconsent"?null:consentType),
      consentRequired : (consentType==="Noconsent"?false:true),
      finInfoId: selectedBank.fiId,
      name: values.bankName,
      products: [selectedLoanProductCode.loanProductName],
      productId: selectedLoanProductCode.loanProductId,
      routingConfigurationSet: routingConfigurationSet,
      aggregatorConfigId:values?.aggregator!="oneflo"? values?.aggregator :"",
      productPlanDetails:productPlanDetails,
      preferenceOrder:values?.preferenceOrder
    };
    setSelectedProductPlanName(productPlan.find((item)=>selectedProductPlan === item?.productPlanId))
    
    API_SERVICE.addLender(payload)
      .then(({ data }) => {
        if (data) {
          if (data.message) {
            notification.success({ message: data.message });
          }
          let tmpList
          const plan = productPlan?.find(
            (item) => item.productPlanId == values.productPlan
          );
          if (selectedLoanProductCode.loanProductName != "Credit Card"){
            tmpList = [...productList];
            tmpList.push({
              ProductName: selectedLoanProductCode.loanProductName,
              routingConfigurationSet: routingConfigurationSet,
            });
          }
          else{
            tmpList = [...productList];          
            tmpList.push({
            productPlanName: plan?.productPlanName,
            submissionType: routingMode,
            status: values.status ? "ACTIVE" : "INACTIVE"
        })
          }
          ;
          setProductsList(tmpList);
          setProductPlan([])
          setAggregatorList([])
          setSelectedAggregator("")
          setIndividualCaseRouting(false)
          setBulkCaseRouting(false);
          const tmpReset = ["product",
            "apikey",
            "apiid",
            "copyconfiguration",
            "individualCaseRouting",
            "hub",
            "pincode",
            "city",
            "lenderLoginUrl",
            "bulkCaseRouting",
            "hub_bulk",
            "pincode_bulk",
            "city_bulk",
            "lenderLoginUrl_bulk",
            "productPlan",
            "preferenceOrder",
            "bankName"
          ]
          pIDetailList?.map((item) => {
            tmpReset.push(item.key);
          })
          addLenderForm.resetFields(tmpReset);
          setProductPlanList(data.payload.productPlanDetails);
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      });
  };

  useEffect(() => {
    getFiList();
  }, []);

  const getFiList = () => {
    API_SERVICE.getFiList({ pageSize: 500, financierCategory:"LENDER" }).then(({ data }) => {
      if (data?.payload.content) {
        setFiList(data.payload.content);
        setLoading(false);
      }
    }).finally(() => {
      setLoading(false);
    });
  };

  const updatePartnerIdentificationDetails = (values) => {
    const keys = Object.keys(values);
    const filterDataObject = [] as any;

    pIDetailList?.map((data) => {
      let filterData = keys.filter((item) => item === data?.key);
      filterDataObject.push({
        key: filterData[0],
        value: values[filterData[0]],
      });
    });

    const params = {
      lenderId: selectedLenderId,
      productIds: [selectedLoanProductCode.loanProductId],
      partnerIdentificationKeyDetail: {
        partnerIdentificationDetails: filterDataObject,
      },
    };

    API_SERVICE.updatePartnerIdentificationDetails(
      selectedLenderId,
      params
    ).then(({ data }) => {
      addLenderHandler(values);
    }).catch((e: any) => {
      notification.error({ message: API_SERVICE.handleErrors(e) });
    });
  };

  const getPartnerIdentificationDetails = (lenderId, loanProductCode) => {
    API_SERVICE.getPartnerIdentificationDetails(
      lenderId,
      loanProductCode.loanProductId
    ).then(({ data }) => {
      setPIDetailList(data?.payload?.partnerIdentificationDetails ?? []);
    });
  };

  const changeBankHandler = (value: any) => {
    let fiItem = fiList.find((item) => item.financierName == value);
    setHubList(fiItem.hubDetails);
    setProducts(fiItem?.lenderLoanDefinition?.allLoanTypes);
    setSelectedLenderId(fiItem.fiId);
    setPIDetailList([]);
    setSelectedLoanProductCode(undefined);
    // if (selectedLoanProductCode) {
    //   getPartnerIdentificationDetails(fiItem.fiId, selectedLoanProductCode);
    // }
    addLenderForm.setFieldsValue({
      product: null
    })
  };

  const changeProductHandler = (value: any) => {
    const productFiltered = products?.filter(
      (item) => item.loanProductId == value
    );
    if ((productFiltered?.length ?? 0) > 0) {
      setSelectedLoanProductCode(productFiltered[0]);
      if (selectedLenderId) {
        getPartnerIdentificationDetails(selectedLenderId, productFiltered[0]);
      }
      if (productFiltered[0]?.loanProductName == "Credit Card") {
        getProductPlanList(productFiltered[0]?.loanProductId)
        getAggregators(1,1000,productFiltered[0]?.loanProductName)
      }
    }
  };

  const getAggregators = (
    pageNo: number = 1,
    pageSize: any = 10,
    searchParam: any = null
) => {
    const params = {
        pageNo: pageNo,
        pageSize: pageSize,
        searchParam: searchParam,
        aggregatorConfigStatus:"ACTIVE"
    };
    setLoading(true);
    API_SERVICE.getAggregators(params)
        .then((data) => {
            let tmpAggregatorList = data?.data?.payload?.content ?? []
            tmpAggregatorList.push({id:"oneflo", name:"OneFlo (default)"})
            setAggregatorList(tmpAggregatorList)
         })
        .catch((e: any) => {
            API_SERVICE.handleErrors(e);
        })
        .finally(() => {
            setLoading(false);
        });
};

const getProductPlanList = (loanProductCode) => {
  setLoading(true);
  API_SERVICE.getProductPlanList({
    pageSize: 100,
    loanProductId: loanProductCode,
    provider: selectedLenderId,
    productPlanStatus: "ACTIVE"
  })
    .then(({ data }) => setProductPlan(data?.payload?.content ?? []))
    .finally(() => setLoading(false));
};

const changeProductPlanHandler = (value: any) => {
        setSelectedProductPlan(value);    
  };

  const changeAggregatorHandler =  (value: any) => {   
      setSelectedAggregator(value);   
  };

  const changeHubHandler = (value: any, isBulkCase: boolean) => {
    let selectedHub = hubList.find((item) => item.hubName == value);
    if(isBulkCase) {
      addLenderForm.setFieldsValue({
        pincode_bulk: selectedHub?.pincode ?? selectedHub?.pinCode,
      });
    } else {
      addLenderForm.setFieldsValue({
        pincode: selectedHub?.pincode ?? selectedHub?.pinCode,
      });
    }
  };

  const actionAdd = () => {
    setRegionalDSAID([...regionalDSAID, ""]);
  };

  const columns = [
    {
      title: "Product Name",
      dataIndex: "ProductName",
      key: "ProductName",
      render: (text) => <p style={{ color: "blue" }}>{text}</p>,
    },
    {
      title: "Routing Mode",
      dataIndex: "RoutingMode",
      key: "RoutingMode",
      render: (_: any, record: any) => {
        return record?.routingConfigurationSet?.map((data: any) => {
          return (
            <div>{`${getEnumValue("ROUTING_TYPE", data?.routingType)} - ${getEnumValue("LENDER_SUBMIT_TYPE", data?.submissionType)}`}</div>
          );
        });
      }
    },
  ];

  const productColumns : ColumnsType<any>  = [
    {
      title: "Product Plan",
      dataIndex: "productPlanName",
      key: "productPlanName",
      render: (text) => <p style={{ color: "blue" }}>{text}</p>,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
     },
   ]

 

  const actionSkip = () => {
    setShowDSAIdView(false);
  };

  const btnRoundRadioStyles: any = {'--borderColor': appColors?.appPrimaryColor ?? ""};
  const btnPrimaryStyles : any = {'--btnColor' :appColors?.appPrimaryColor ?? ""};
  const btnDefaultBorderStyle: any = {'--borderColor': appColors?.appSecondaryColor ?? ""};

  const renderDSAIdView = () => {
    return (
      <>
        <Form.Item name="dsaId" style={{ marginTop: "5px" }}>
          <Radio.Group        
            name="dsaId"
            onChange={(ev) => {
              setSelectedDSAId(ev.target.value);
            }}
            // value={selectedDSAId}
            defaultValue={selectedDSAId}
          >
            <Radio value={1}>{"Global DSA ID"}</Radio>
            <Radio value={2}>{"Regional DSA ID"}</Radio>
          </Radio.Group>
        </Form.Item>

        <Text style={{ paddingTop: "20px", fontSize: "14px" }}>
          {selectedDSAId == 1
            ? "Do you have a lender issued DSA ID? if Yes, please enter the details below."
            : "Do you have DSA ID? if Yes, select one"}
        </Text>

        {selectedDSAId == 1 ? (
          <Form.Item
            className="field-bg-border"
            name="globalDsaId"
            style={{ marginTop: "5px" }}
            rules={[{ required: true, message: "Please enter Global DSA ID" }]}
          >
            <Input className="custom-input" placeholder="Enter Global DSA ID" />
          </Form.Item>
        ) : (
          regionalDSAID?.map((item, index) => {
            return (
              <Row gutter={[8, 8]}>
                <Col span={9}>
                  <Form.Item
                    className="field-bg-border"
                    name={`hubName-${index}`}
                    rules={[
                      { required: true, message: "Please enter hub name" },
                    ]}
                  >
                    <Select
                      showSearch
                      className="custom-select"
                      placeholder="Hub Name"
                      optionFilterProp="children"
                      onChange={(value, option) => changeHubHandler(value, false)}
                      filterOption={(input, option) =>
                        (option!.children as unknown as string)
                          ?.toLowerCase()
                          ?.includes(input?.toLowerCase())
                      }
                    >
                      {hubList?.map((item: any, i: number) => (
                        <Option key={i} value={item.hubName}>
                          {item.hubName}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={13}>
                  <Form.Item
                    className="field-bg-border"
                    name={`regionalDsaid-${index}`}
                    rules={[
                      {
                        required: true,
                        message: "Please enter Regional DSA ID",
                      },
                    ]}
                  >
                    <Input
                      className="custom-input-number"
                      name="payoutAmount"
                      placeholder="Enter Regional DSA ID"
                    />
                  </Form.Item>
                </Col>
                <Col span={2}>
                  <Button
                    className="btn-add"
                    hidden={index != 0}
                    onClick={actionAdd}
                  >
                    <img src={add} alt="" width={20} />
                  </Button>
                </Col>
              </Row>
            );
          })
        )}

        <Form.Item style={{ marginTop: "50px" }}>
          <Space className="buttons">
            <Button
              size="large"
              //   loading={loading}
              type="primary"
              htmlType="submit"
            >
              Continue
            </Button>
            <Button size="large" htmlType="button" onClick={() => actionSkip()}>
              Skip
            </Button>
          </Space>
        </Form.Item>
      </>
    );
  };

  const renderAggregatorList = () =>{
    return(
      <Form.Item
                className="field-bg-border"
                name="aggregator"
                label="Select Aggregator"
                rules={[{ required: true, message: "Please select Aggregator" }]}
            >
            <Select
                showSearch
                className="custom-select"
                placeholder="Please select Aggregator"
                optionFilterProp="children"
                onChange={(value) => changeAggregatorHandler(value)}
                filterOption={(input, option) =>
                  (option!.children as unknown as string)
                    ?.toLowerCase()
                    ?.includes(input?.toLowerCase())
                }
            >
            {aggregatorList?.map((item: any, i: number) => (
              <Option key={i} value={item.id}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
    )
  }

  const renderIndividualCaseRouting = (isBulkCase: boolean) => {
    return <>
        <Form.Item
          name={`routingMode${isBulkCase?"_bulk":""}`}
          style={{ marginTop: "5px", marginLeft:"20px" }}
        >
          <Radio.Group
            defaultValue={isBulkCase ? "LOGIN" : "API"}
            className="dynamic-radio d-flex-column"
            style={btnRoundRadioStyles}
            onChange={(e) =>{
              if(isBulkCase) {
                setRoutingModeBulk(e?.target?.value)
              } else {
                setRoutingMode(e?.target?.value)
              }
              // setConsentType(e?.target?.value==="API"?'GLOBAL':"Noconsent")
            }}
            name={`routingMode${isBulkCase?"_bulk":""}`}
          >
            <Radio value={"API"}>
              API
            </Radio>
            {!isBulkCase && 
              <Radio value={"AUTOMATION"}>Automation</Radio>
            }
            <Radio value={"LOGIN"}>Login</Radio>
            {!isBulkCase && 
              <Radio value={"WEBLINK"}>Weblink</Radio>
            }
          </Radio.Group>
        </Form.Item>
        {(selectedLoanProductCode?.loanProductName === "Credit Card" && routingMode === "API") && 
          renderAggregatorList()
        }
        {(isBulkCase ? routingModeBulk == "API" : routingMode == "API") ? (
          <>
            {selectedAggregator === "oneflo" && 
              pIDetailList?.map((item) => {
              return (
                <Form.Item
                  className="field-bg-border"
                  name={`${item.key}${isBulkCase?"_bulk":""}`}
                  label={item.key}
                  rules={[
                    { required: true, message: `Please enter ${item.key}` },
                  ]}
                >
                  <Input
                    placeholder={`Enter ${item.key}`}
                    className="custom-input"
                  />
                </Form.Item>
              );
            })}
          </>
        ) : (
          <>
            <Form.Item
              className="field-bg-border"
              label="Hub"
              rules={[{ required: true, message: "Please select Hub" }]}
              name={`hub${isBulkCase?"_bulk":""}`}
            >
              <Select
                showSearch
                className="custom-select"
                placeholder="Please select Hub"
                optionFilterProp="children"
                onChange={(value, option) => changeHubHandler(value, isBulkCase)}
                filterOption={(input, option) =>
                  (option!.children as unknown as string)
                    ?.toLowerCase()
                    ?.includes(input?.toLowerCase())
                }
              >
                {hubList?.map((item: any, i: number) => (
                  <Option key={i} value={item.hubName}>
                    {item.hubName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              className="field-bg-border"
              name={`pincode${isBulkCase?"_bulk":""}`}
              label="Pin Code"
            >
              <Input
                readOnly
                className="custom-input"
                placeholder="Please enter Pin Code"
              />
            </Form.Item>
            <Form.Item
              className="field-bg-border"
              name={`city${isBulkCase?"_bulk":""}`}
              label="City"
              rules={[{ required: true, message: "Please enter City" }]}
            >
              <Input placeholder="Please enter City" className="custom-input" />
            </Form.Item>
            {(isBulkCase ? routingModeBulk == "LOGIN" : routingMode == "LOGIN") && (
              <Form.Item
                className="field-bg-border"
                name={`lenderLoginUrl${isBulkCase?"_bulk":""}`}
                label="Lender Link"   
              >
                <Input placeholder="Please enter Lender Link" className="custom-input" />
              </Form.Item>
            )}
          </>
        )}
    </>
  }

  const renderOther = () => {
    return (
      <>
        <Form.Item
          className="field-bg-border"
          name="product"
          label="Product"
          rules={[{ required: true, message: "Please select Product Name" }]}
        >
          <Select
            showSearch
            className="custom-select"
            placeholder="Please select Product"
            optionFilterProp="children"
            onChange={(value, option) => changeProductHandler(value)}
            filterOption={(input, option) =>
              (option!.children as unknown as string)
                ?.toLowerCase()
                ?.includes(input?.toLowerCase())
            }
          >
            {products?.map((product: any, i: number) => (
              <Option key={i} value={product.loanProductId}>
                {product.loanProductName}
              </Option>
            ))}
          </Select>
        </Form.Item>
        {selectedLoanProductCode?.loanProductName === "Credit Card" && (
          <Form.Item
          className="field-bg-border"
          name="productPlan"
          label="Product Plan"
          // rules={[{ required: true, message: "Please select Product Plan" }]}
        >
          <Select
            showSearch
            className="custom-select"
            placeholder="Please select Product Plan"
            optionFilterProp="children"
            onChange={(value, option) => changeProductPlanHandler(value)}
            filterOption={(input, option) =>
              (option!.children as unknown as string)
                ?.toLowerCase()
                ?.includes(input?.toLowerCase())
            }
          >
            {productPlan?.map((product: any, i: number) => (
              <Option key={i} value={product.productPlanId}>
                {product.productPlanName}
              </Option>
            ))}
          </Select>
        </Form.Item>
        )}
        <Radio.Group
          value={consentType}
          className="dynamic-radio"
          style={btnRoundRadioStyles}
          onChange= { (e) => {
            setConsentType(e?.target?.value)
            setConsentRequired(e?.target?.value=="Noconsent")  
          }}
          name="consentType">
          <Radio value = {"Noconsent"}>No Consent</Radio>
          <Radio value = {"GLOBAL"}>Global</Radio>
          <Radio value = {"INDIVIDUAL"}>Individual</Radio>
        </Radio.Group>

        <Form.Item
          name="individualCaseRouting"
          style={{ marginTop: "5px" }}
          label="Select Case Routing Mode"
        >
            <Checkbox 
              onChange={(e: any) => {
                setIndividualCaseRouting(e?.target?.checked)
                setRoutingMode("API")
              }}
            >
              Individual Case Routing
            </Checkbox>
        </Form.Item>

        {individualCaseRouting && renderIndividualCaseRouting(false)}
        
        <Form.Item
          name="bulkCaseRouting"
          style={{ marginTop: "5px" }}
        >
            <Checkbox 
              onChange={(e: any) => {
                setBulkCaseRouting(e?.target?.checked)
              }}
              disabled={selectedLoanProductCode?.loanProductName==="Credit Card"}
            >
              Bulk Case Routing
            </Checkbox>
        </Form.Item>

        {bulkCaseRouting && renderIndividualCaseRouting(true)}

          <Form.Item 
            name="preferenceOrder"
            label="Preference Order"
            className="field-bg"
            rules={[
                {
                  validator: (_, value) => {
                    if (value === undefined || value === null) {
                      return Promise.resolve(); // Let 'required' rule handle emptiness
                    }
                    if (value >= 1 && value <= 5) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Enter a number between 1 and 5"));
                  },
                }
              ]}
            >
              <InputNumber 
                className="custom-input-number" 
                placeholder="Preference Order"
              />              
          </Form.Item>
      
        <Form.Item
          initialValue={true}
          name="status"
          label="Status"
          style={{ color: "green" }}
        >
          <Switch defaultChecked style={{'--bgColor': appColors?.appPrimaryColor ?? ""} as any}/>
        </Form.Item>

        <Form.Item style={{ marginTop: "50px" }}>
          <Space className="buttons">
            <Button
              size="large"
              //   loading={loading}
              type="primary"
              htmlType="submit"
              className="dynamic-btn-primary"
              style={btnPrimaryStyles}
            >
              Add
            </Button>
            <Button
            className="dynamic-btn-default"
            style={btnDefaultBorderStyle}
              size="large"
              htmlType="button"
              onClick={() => addLenderForm.resetFields()}
            >
              Clear
            </Button>
            <Button
               className="dynamic-btn-default"
               style={btnDefaultBorderStyle}
              size="large"
              htmlType="button"
              onClick={() => history.goBack()}
            >
              Finish
            </Button>
          </Space>
        </Form.Item>
      </>
    );
  };

  return (
    <div className="content-box">
      <Form
        size="large"
        layout="vertical"
        form={addLenderForm}
        autoComplete="off"
        onFinish={addLender}
      // initialValues={{ ...formData }}
      >
        <Row gutter={[64, 16]}>
          <Col span={10}>
            <Form.Item
              className="field-bg-border"
              name="bankName"
              label="Lender Name"
              rules={[{ required: true, message: "Please select Lender Name" }]}
            >
              <Select
                showSearch
                className="custom-select"
                loading={loading}
                placeholder="Please select Lender Name"
                optionFilterProp="children"
                onChange={(value, option) => changeBankHandler(value)}
                filterOption={(input, option) =>
                  (option!.children as unknown as string)
                    ?.toLowerCase()
                    ?.includes(input?.toLowerCase())
                }
              >
                {fiList?.sort(function (a: any, b: any) {
                  if (a.financierName.toLowerCase() < b.financierName.toLowerCase()) return -1;
                  if (a.financierName.toLowerCase() > b.financierName.toLowerCase()) return 1;
                  return 0;
                })
                  ?.map((item: any, i: number) => (
                    <Option key={i} value={item.financierName}>
                      {item.financierName}
                    </Option>
                  ))}
              </Select>
            </Form.Item>

            {showDSAIdView ? renderDSAIdView() : renderOther()}
          </Col>

          <Col span={14}>
            {!showDSAIdView && (
              selectedLoanProductCode?.loanProductName != "Credit Card" ? (
              <Card className="Added-Product-List">
                <Title level={3}>Added Product List</Title>

                <Table
                  scroll={{ y: 300 }}
                  bordered={false}
                  pagination={false}
                  dataSource={productList}
                  columns={columns}
                ></Table>
              </Card>
            ) : (
              <Card className="Added-Product-List">
                <Title level={3}>Added Product Plans</Title>

                <Table
                  scroll={{ y: 300 }}
                  bordered={false}
                  pagination={false}
                  dataSource={productPlanList}
                  columns={productColumns}
                ></Table>
              </Card>
            ))}
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default AddLender;
